export default __webpack_public_path__ + "static/media/Logo_PBP.bf328516.svg";